import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=5e21ea2f"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports